<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="businessinfo" :rules="rules" ref="businessrule" label-width="120px" class="">
			<el-row>
				<el-col :span="8">
					<el-form-item label="商家名称" prop="name">
						<el-input clearable v-model="businessinfo.name" maxlength="50"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="法人姓名" prop="legalperson">
						<el-input clearable v-model="businessinfo.legalperson" maxlength="15"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="联系人" prop="contactperson">
						<el-input clearable v-model="businessinfo.contactperson" maxlength="15"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="联系电话" prop="phone">
						<el-input clearable v-model="businessinfo.phone" maxlength="11"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="入驻时间" prop="jointime">
                        <el-date-picker style="width: 100%;" v-model="businessinfo.jointime" type="date" placeholder="选择日期"></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="营业执照" >
						<el-upload :action="fileuploadUrl" :data="filetype" :file-list="bigPicture" accept=".jpeg,.jpg,.png"
							:before-upload="(file) => handleBeforeUpload(file) "
							list-type="picture-card" :limit="1" :multiple="false" :on-error="handleUploadError"
							:on-preview="handlePictureCardPreview" :headers="uploadheader"
							:on-remove="(file, fileList) => handleRemove(file, fileList)" 
							:on-exceed="(file, fileList) => handleExceed(file, fileList)"
							:on-success="(response, file, fileList) => handleUploadSucc(response, file, fileList)">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-dialog :modal="true" :append-to-body="true" :modal-append-to-body="false" :visible.sync="pictureVisible">
			<img width="100%" :src="pictureImageUrl" alt="">
		</el-dialog>
		<div style="text-align: center;">
			<el-button plain @click="closeDlg">取消</el-button>
			<el-button type="primary" @click="saveBusiness">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { nfsprefix, baseUrl,prefix } from '/static/baseUrl.js'
	import { queryBusinessDetail,addBusiness, editBusiness } from '/static/apiUrl.js'
	export default {
		name : 'BusinesssDetail',
		data() {
			return {
				editok : false,
				pictureVisible: false,				
				pictureImageUrl : '',
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},
				fileuploadUrl : baseUrl+prefix+'/api/entrybusinessfile/upload',
				filetype: {
					type: "",
				},
				businessinfo : {
					"id": "",
					"name": "",
					"legalperson": "",
					"phone": "",
					"contactperson": "",
					"businesslicense": "",
					"jointime": "",
					"state": "",
				},
				bigPicture : [],
				rules:{
					name: [
						{ required: true, message: '请输入商家名称', trigger: 'blur' }
					],
					jointime: [
						{ required: true, message: '入驻时间', trigger: 'blur' }
                    ],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			select_id : {
				type: String,
				required: false
			},
		},
		watch: {
			select_id: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.clearData()
					this.businessDetail(newVal)
				}
			},
		},
		methods: {
			clearData(){
				this.businessinfo = {
					"id": "",
					"name": "",
					"legalperson": "",
					"phone": "",
					"contactperson": "",
					"businesslicense": "",
					"jointime": "",
					"state": "",
				}
				this.bigPicture = []
				this.pictureImageUrl = ''
				this.editok = false
			},
			closeDlg() {
				this.$emit("needRefrash",false,false)
			},
			businessDetail(id){
				if(id !== undefined && id !== null && id != ''){
					queryBusinessDetail({id : id}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.businessinfo = res.data
							if(res.data.businesslicense && res.data.businesslicense.length > 0){
								this.bigPicture.push({
									id : this.businessinfo.businesslicense,
									name : this.businessinfo.name,
									url :  baseUrl+nfsprefix +this.businessinfo.businesslicense,
									size : 0,
									status : 'success',
									uid : 0,
								})
							}
						}
					})
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
				this.bigPicture.splice(0,1)
			},
			handlePictureCardPreview(file) {
				this.pictureImageUrl = file.url
				this.pictureVisible = true
			},
			handleUploadSucc(response, file, fileList){
				console.log(response,file,fileList)
				if(0 == response.code){
					this.bigPicture.push({
						id : response.data,
						url : file.url,
						size : file.size
					})
				}else{
					this.$message.error("上传失败")
				}
			},
			handleUploadError(err, file, fileList){
				console.log(err,file,fileList)
			},
			handleExceed(file, fileList) {
				console.log(file,fileList)
				if(this.bigPicture.length >0){
					this.$message.warning("只能上传一张图片")
				}
			},
			handleBeforeUpload(file){
				let types = [
					"image/jpeg",
					"image/jpg",
					"image/png"
				];
				const isImage = types.includes(file.type);
				const isLtSize = file.size / 1024 / 1024 < 5;
				if (!isImage) {
					this.$message.warning("上传图片只能是 JPG、JPEG、PNG 格式!");
					return false;
				}
				if (!isLtSize) {
					this.$message.warning("上传图片大小不能超过 5MB!");
					return false;
				}
				return file
			},
			saveBusiness(){
				this.$refs["businessrule"].validate((valid) => {
					if (valid) {
						if (this.bigPicture.length > 0) {
							this.businessinfo.businesslicense = this.bigPicture[0].id
						} else {
							this.businessinfo.businesslicense = ""
						}
						if(this.businessinfo.id != null && this.businessinfo.id != ''){  //编辑
							editBusiness(this.businessinfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true,false)
									this.$message.success("修改商家信息成功")
								}else{
									this.$emit("needRefrash",false)
									this.$message.error(res.msg,true)
								}
							})
						}else{ //新增
							addBusiness(this.businessinfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.clearData();
									this.$emit("needRefrash",true,false)
									this.$message.success("添加商家信息成功")
								}else{
									this.$emit("needRefrash",false,true)
									this.$message.error(res.msg)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>